import { Button, Chip, Link, Typography, Divider, Grid2 } from '@mui/material';
import RichTextContent from 'components/RichTextContent';
import { BroadcastifyFeed } from 'features/broadcastify/broadcastify.types';
import { useTranslation } from 'react-i18next';

type BroadcastifyFeedDetailsProps = BroadcastifyFeed;

export const BroadcastifyFeedDetails = (
  props: BroadcastifyFeedDetailsProps,
): JSX.Element => {
  const { name, description, listeners, online, listenUrl } = props;
  const { t } = useTranslation();

  return (
    <Grid2 container spacing={2}>
      <Grid2 size={12} container spacing={2}>
        <Grid2 size={12}>
          <Typography variant="h3" sx={{ fontWeight: 'fontWeightBold' }}>
            {name}
          </Typography>

          <Chip
            label={`${listeners} listeners`}
            variant="watchduty"
            color={online ? 'success' : 'error'}
            sx={{ mt: 0.5 }}
          />
        </Grid2>

        <Grid2 size={12}>
          <Button
            size="large"
            fullWidth
            component={Link}
            href={listenUrl}
            target="_blank"
          >
            {t('broadcastifyFeed.openFeed')}
          </Button>
        </Grid2>
      </Grid2>

      {description && (
        <>
          <Grid2 size={12}>
            <Typography variant="h3" sx={{ mt: 2 }}>
              {t('broadcastifyFeed.information')}
            </Typography>
          </Grid2>

          <Grid2
            size={12}
            sx={(theme) => ({
              mx: { xs: `-${theme.spacing(2)}` },
              width: { xs: `calc(100% + ${theme.spacing(4)})` },
            })}
          >
            <Divider />
          </Grid2>

          <Grid2 size={12}>
            <RichTextContent content={description} />
          </Grid2>
        </>
      )}
    </Grid2>
  );
};
